import styled from '@emotion/styled';

export const PrimaryBlackButton = styled.button`
  padding: 11.5px 28px;
  font-size: 14px;
  font-weight: 600;
  background-color: var(--ink);
  height: 40px;
  border-radius: 999px;
  color: white;
  border: 1.5px solid var(--ink);
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    background-color 0.2s ease;
  display: flex;
  cursor: pointer;
  gap: 8px;

  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #1d2e24;
    transform: translateY(-1px);
  }

  &.large {
    font-size: 16px;
    padding: 9px 20px;
  }
`;

export const PrimaryWhiteButton = styled.button`
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  background-color: white;
  height: 40px;
  border-radius: 999px;
  color: var(--ink);
  border: 1.5px solid var(--line-2);
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    background-color 0.2s ease;
  display: flex;
  cursor: pointer;
  gap: 8px;

  justify-content: center;
  align-items: center;

  &:hover {
    background-color: var(--ground);
    transform: translateY(-1px);
  }

  &.large {
    font-size: 16px;
    padding: 9px 20px;
  }

  &.in-form {
    font-size: 16px;
    padding: 24px 42.5px;
    line-height: 22px;
  }

  &.large-x-padding {
    padding: 24px;
    padding-left: 0px;
    padding-right: 0px;
  }

  &.clear {
    background: white;
    color: ${({ theme }) => theme.palette.grayTextColor};
  }

  &.large {
    font-size: 16px;
    line-height: 16px;
    padding: 16px;
    height: 50px;
  }

  &.cancel {
    margin-left: auto;
  }
`;

export const FormNavigatebtn = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: transparent;
  border: 0px solid transparent;
  color: ${({ theme }) => theme.palette.blueColor};
  font-weight: 700;
  font-size: 14;
  margin: 0;
  padding: 0;
  width: fit-content;

  cursor: pointer;
`;
